import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';
import styles from './StartProjectSection.module.less';
import vrHeadset from 'assets/img/vr-headset.png';
import loginConfig from '../../../auth/loginConfig';

export default function StartProjectSection() {
	const { loginWithRedirect } = useAuth0();
	const { t } = useTranslation();
	return (
		<>
			<div className={styles.StartProjectSectionBackground}>
				<div className={styles.StartProjectSectionContainer}>
					<img
						src={vrHeadset}
						alt="VR Headset with reflection"
						className={styles.StartProjectSectionImg}
					/>
					<div
						onClick={() =>
							loginWithRedirect({
								...loginConfig,
								redirectUri: `${window.location.origin}/projects`,
							})
						}
					>
						<div className={styles.StartProjectSectionButton}>
							Start Your Project
						</div>
					</div>
					<div className={styles.StartProjectSectionText}>
						Developers play a critical role in expanding the Omni One content
						ecosystem. We aim to grow hand-in-hand with our developers and be at
						your side throughout your journey.
					</div>
				</div>
			</div>
		</>
	);
}
